var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sign-up"},[_c('SignupTemplate')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }